/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { slug } from '../../../common';
import Page from 'flarum/common/components/Page';
import AchievementCategoriesState from '../../../common/states/AchievementCategoriesState';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Placeholder from 'flarum/common/components/Placeholder';
import AchievementsHero from './AchievementsHero';
import AchievementItem from '../../../common/components/AchievementItem';
import AchievementCategoriesDropdown from './AchievementCategoriesDropdown';
const t = function () {
  return app.translator.trans(...arguments);
};
const prfx = `${slug}.forum.achievements`;
export default class AchievementsPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.categoryId = m.route.param('category');
    app.history.push('achievements');
    this.bodyClass = 'App--achievements';
    app.setTitle(t(`${prfx}.title`));
    this.state = new AchievementCategoriesState();
    this.state.refresh(true, true);
  }
  onbeforeupdate(vnode) {
    super.onbeforeupdate(vnode);
    const {
      loading,
      achievement_categories
    } = this.state;
    if (this.categoryId === 'undefined' && !loading && achievement_categories.length) {
      m.route.set(app.route('achievements', {
        category: achievement_categories[0].id()
      }));
    }
  }
  view() {
    const {
      loading,
      achievement_categories,
      error
    } = this.state;
    const category = this.categoryId ? achievement_categories?.find(c => +c.id() === +this.categoryId) : null;
    const notFound = !loading && !error && !!achievement_categories && !!this.categoryId && this.categoryId !== 'undefined' && !category;
    return m("div", {
      className: "AchievementsPage"
    }, m(AchievementsHero, {
      category: category,
      loading: loading,
      achievement_categories: achievement_categories
    }), m("div", {
      className: "container"
    }, loading && m(LoadingIndicator, null), m("div", {
      className: "sideNavContainer"
    }, m("nav", {
      className: "AchievementsPage-nav sideNav"
    }, !!achievement_categories?.length && m(AchievementCategoriesDropdown, {
      achievement_categories: achievement_categories,
      categoryId: this.categoryId
    })), m("div", {
      className: "AchievementsPage-content sideNavOffset"
    }, !loading && error && m(Placeholder, {
      text: t('core.lib.error.generic_message')
    }), notFound && m(Placeholder, {
      text: t('core.lib.error.not_found_message')
    }), category?.achievements() && category.achievements().sort((a, b) => a.order() - b.order()).filter(a => !!a.levels() && a.levels().length).map(achievement => m(AchievementItem, {
      achievement: achievement,
      showDetails: true,
      link: app.route('achievement', {
        id: achievement.id()
      }),
      clickable: true
    }))))));
  }
}
flarum.reg.add('glowingblue-gamilytics', 'forum/achievements/components/AchievementsPage', AchievementsPage);